import React from "react";
import {
  FaSearch,
  FaBell,
  FaUserCircle,
} from "react-icons/fa";
import { RiMenuFoldLine, RiMenuUnfoldLine } from "react-icons/ri";
import { useWindowContext } from "../Context/WindowContext";
import { useAuth } from "../Components/StoredDetails";
import ServiceDashboard from "../Forms/ServiceDashboard";
import "./Layout.css";

const Navbar = ({
  title,
  currentMenuPath,
  sidebarOpen,
  toggleSidebar,

  searchQuery,
  handleSearch,
  handleSearchSelect,
  masterSearchQuery,
  handleMasterSearch,
  masterSearchResults,
  handleMasterSearchSelect,
  setMasterSearchResults,

  placeholders,
  index,
  animateOut,

  searchResults,
  showDropdown,
  setShowDropdown,

  setSearchResults,
  onSearchClear,

  User
}) => {

  const { authData, notificationCount } = useAuth();
  const { openWindow } = useWindowContext();
  const user = authData?.user;

  const [searchType, setSearchType] = React.useState("menu");
  const [localMasterQuery, setLocalMasterQuery] = React.useState("");
  const [showTypeDropdown, setShowTypeDropdown] = React.useState(false);
  const typeToggleRef = React.useRef(null);

  const activeSearchValue = searchType === "menu"
    ? (searchQuery ?? "")
    : (masterSearchQuery ?? localMasterQuery ?? "");

  const activeResults = searchType === "menu"
    ? searchResults
    : (masterSearchResults ?? searchResults);

  const isCurrentInputEmpty = activeSearchValue.trim() === "";

  const handleNotificationClick = () => {
    openWindow({
      id: `service-dashboard-${Date.now()}`,
      title: "Service Dashboard",
      icon: <FaBell />,
      content: <ServiceDashboard />,
      pageKey: "ServiceDashboard",
    });
  };

  React.useEffect(() => {
    const handleClickOutsideType = (event) => {
      if (
        typeToggleRef.current &&
        !typeToggleRef.current.contains(event.target)
      ) {
        setShowTypeDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutsideType);
    return () => document.removeEventListener('mousedown', handleClickOutsideType);
  }, [typeToggleRef]);

  return (

    <header className="Navbar">

      {/* Left */}

      <div className="Navbar-Left">

        <button
          className="Sidebar-Toggle"
          onClick={toggleSidebar}
        >
          {sidebarOpen ? <RiMenuFoldLine /> : <RiMenuUnfoldLine />}
        </button>

        <div className="Navbar-Items">

          <div className="Search-Type-Wrapper" ref={typeToggleRef}>
            <button
              className="Search-Type-Button"
              onClick={(e) => {
                e.stopPropagation();
                setShowTypeDropdown((s) => !s);
              }}
              aria-haspopup="menu"
              aria-expanded={showTypeDropdown}
            >
              <FaSearch />
            </button>

            {showTypeDropdown && (
              <div
                className="Search-Type-Dropdown"
                onMouseDown={(e) => e.stopPropagation()}
              >
                <div
                  className={`Search-Type-Item ${searchType === 'menu' ? 'selected' : ''}`}
                  onClick={() => {
                    setSearchType('menu');
                    setShowTypeDropdown(false);
                    setShowDropdown(false);
                    setSearchResults([]);
                    setMasterSearchResults?.([]);
                  }}
                >
                  Menu
                </div>
                <div
                  className={`Search-Type-Item ${searchType === 'master' ? 'selected' : ''}`}
                  onClick={() => {
                    setSearchType('master');
                    setShowTypeDropdown(false);
                    setShowDropdown(false);
                    setSearchResults([]);
                    setMasterSearchResults?.([]);
                  }}
                >
                  Master Data
                </div>
              </div>
            )}
          </div>

          <div className="Navbar-Search-Container">

            <FaSearch className="Navbar-Search-Icon" />

            {searchType === "menu" ? (

              <input
                className="Navbar-Search-Input"
                type="text"
                value={searchQuery}
                onChange={(e) => {
                  handleSearch(e);

                  if (e.target.value.trim() === "") {
                    setSearchResults([]);
                    setMasterSearchResults?.([]);
                    setShowDropdown(false);
                    onSearchClear?.();
                  }
                }}

                onKeyDown={(e) => {

                  if (
                    e.key === "Enter" &&
                    activeResults?.length
                  ) {

                    handleSearchSelect(activeResults[0]);

                  }

                }}

                onFocus={() =>
                  searchResults.length &&
                  setShowDropdown(true)
                }
              />

            ) : (
              <input
                className="Navbar-Search-Input"
                type="text"
                value={masterSearchQuery !== undefined ? masterSearchQuery : localMasterQuery}
                onChange={(e) => {
                  if (handleMasterSearch) {
                    handleMasterSearch(e);
                  } else {
                    setLocalMasterQuery(e.target.value);
                  }

                  if (e.target.value.trim() === "") {
                    setSearchResults([]);
                    setMasterSearchResults?.([]);
                    setShowDropdown(false);
                    onSearchClear?.();
                  }
                }}

                onKeyDown={(e) => {
                  const selectFn = handleMasterSearchSelect ?? handleSearchSelect;
                  if (e.key === "Enter" && activeResults && activeResults.length) {
                    selectFn(activeResults[0]);
                  }
                }}

                onFocus={() => {
                  activeResults && activeResults.length && setShowDropdown(true);
                }}
              />

            )}

            {isCurrentInputEmpty && (

              <span
                className={`Navbar-Search-Placeholder ${animateOut ? "slide-up" : "slide-down"
                  }`}
              >
                {placeholders[index]}
              </span>

            )}

            {showDropdown &&
              activeResults?.length > 0 && (

                <div className="Navbar-Search-Dropdown">

                  {activeResults.map((item, i) => (

                    <div
                      key={i}
                      className="Navbar-Search-Item"
                      onClick={() =>
                        (searchType === "master"
                          ? (handleMasterSearchSelect ?? handleSearchSelect)
                          : handleSearchSelect)(item)
                      }
                    >

                      {item.type === "menu" ? (

                        <>

                          <div className="Navbar-Search-Menu">
                            {item.name}
                          </div>

                        </>

                      ) : (

                        <>

                          <div className="Navbar-Search-Parent">
                            {item.parent.MenuName}
                          </div>

                          <div className="Navbar-Search-Child">
                            {item.data.MenuName}
                          </div>

                        </>

                      )}

                    </div>

                  ))}

                </div>

              )}

          </div>
        </div>
      </div>

      {/* Center */}

      <div className="Navbar-Center">

        <span className="Navbar-Path">

          {currentMenuPath}

        </span>

      </div>

      {/* Right */}

      <div className="Navbar-Right">

        <button
          type="button"
          className="Notification"
          onClick={handleNotificationClick}
          aria-label="Open Service Dashboard"
        >

          <FaBell />

          <span className="Notification-Badge">
            {authData?.notificationCount ?? notificationCount ?? 0}
          </span>

        </button>

        <div
          className="Profile"
        >

          {User?.Image ?

            <img
              src={`data:image/png;base64,${User.Image}`}
              alt=""
              className="Profile-Image"
            />

            :

            <FaUserCircle className="Profile-Icon" />

          }

          <div className="Profile-Info">

            <div className="Profile-Name">

              {user?.UserID}

            </div>

          </div>

        </div>

      </div>

    </header>

  );

};

export default Navbar;